var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wt2-sg wt2-masthead-story-back-icon",on:{"click":_vm.onClick}},[_c('i',{staticClass:"wticon wticon-chevron-left1"}),_vm._v(" Back\n")])}
var staticRenderFns = []

export { render, staticRenderFns }